import { render, staticRenderFns } from "./jiajialePrivte.vue?vue&type=template&id=3c1cae19&scoped=true&"
import script from "./jiajialePrivte.vue?vue&type=script&lang=js&"
export * from "./jiajialePrivte.vue?vue&type=script&lang=js&"
import style0 from "./jiajialePrivte.vue?vue&type=style&index=0&id=3c1cae19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1cae19",
  null
  
)

export default component.exports